import React from 'react';
import Banner from '../../../../../../UI/Banner/Banner';
import bannerImage from "../../../../../../../assets/images/satellite/banner.png";
const OutsourcingAdvantagesBanner = (props) => (
    <Banner
        id="outsourcing-advantages-banner"
        className="banner black pb-5 services-banner"
        title="services:outsourcingAdvantages.section-1.title"
        text="services:outsourcingAdvantages.section-1.txt"
        t={props.t}
        imageBannerRight={bannerImage}
        timeDelay={1.55}
        noText
    />
);

export default OutsourcingAdvantagesBanner;
